import React, { Component } from 'react';
import './App.css';

class Icon extends React.Component {
  _mergeStyles(...args) {
    // This is the m function from "CSS in JS" and can be extracted to a mixin
    return Object.assign({}, ...args);
  }
  renderGraphic() {
    switch (this.props.icon) {
      case 'octocat':
        return (
          <g id="5151e0c8492e5103c096af88a5006e1e"><g /><path id="XMLID_1_" display="inline" d="M6.962,266.753c22.59-5.641,53.305-13.324,107.118-14.753
    c-1.487-2.974-2.83-6.053-4.019-9.228c-20.94-0.182-85.43,2.792-107.521,8.25c-0.125,0.039-0.259,0.048-0.393,0.048
    c-0.739,0-1.42-0.508-1.602-1.256c-0.211-0.873,0.326-1.774,1.208-1.995c21.89-5.41,84.825-8.413,107.118-8.355
    c-5.017-14.753-7.233-31.655-7.233-50.523c0-33.516,10.437-46.159,24.46-64.02c-10.724-38.197,3.847-64.307,3.847-64.307
    s22.533-4.671,65.132,25.832c23.089-9.89,84.647-10.714,113.77-2.196c17.88-11.818,50.571-28.585,63.77-23.895
    c3.568,5.755,11.262,22.513,4.662,59.348c4.489,8.077,27.761,25.286,27.856,73.928c-0.384,17.938-2.245,33.084-5.698,45.899
    c55.54-0.47,88.212,4.115,110.715,8.259c0.883,0.182,1.478,1.036,1.324,1.928c-0.153,0.787-0.844,1.353-1.611,1.353
    c-0.115,0-0.211-0.009-0.326-0.019c-22.466-4.163-55.194-8.729-111.061-8.221c-0.979,3.252-2.072,6.341-3.262,9.286
    c19.013,0.633,71.233,2.667,113.823,15.693c0.883,0.269,1.362,1.189,1.094,2.072c-0.211,0.7-0.863,1.16-1.573,1.16
    c-0.153,0-0.326-0.019-0.479-0.076c-43.185-13.199-96.538-15.012-114.283-15.598c-15.444,33.929-47.118,46.59-98.322,51.856
    c16.595,10.446,21.353,23.548,21.353,59.003c0,35.453-0.479,40.211-0.364,48.363c0.173,13.383,19.779,19.789,19.051,24.096
    c-0.729,4.299-16.403,3.607-23.731,1.047c-20.758-7.232-18.687-24.5-18.687-24.5l-0.69-47.404c0,0,1.42-25.516-8-25.516
    c0,5.131,0,59.242,0,77.592c0,16.863,11.799,21.986,11.799,28.221c0,10.715-21.563-1.016-28.202-7.703
    c-10.134-10.168-8.982-31.73-8.733-48.785c0.23-16.471-0.153-52.49-0.153-52.49l-6.877,0.145c0,0,2.82,78.686-3.626,93.025
    c-8.335,18.408-33.477,24.74-33.477,16.355c0-5.641,6.196-3.846,9.621-16.488c2.925-10.754,1.928-90.975,1.928-90.975
    s-8.057,4.768-8.057,19.789c0,6.877-0.192,46.158-0.192,57.852c0,14.705-20.883,23.078-30.917,23.078
    c-5.084,0-11.405-0.248-11.405-2.943c0-6.801,19.099-10.793,19.099-24.941c0-12.268-0.269-43.826-0.269-43.826
    s-9.631,1.648-23.367,1.648c-34.628,0-45.583-22.1-50.792-34.465c-6.782-16.105-15.578-23.673-24.921-29.717
    c-5.736-3.712-7.06-8.096-0.422-9.343c30.657-5.774,38.494,34.763,58.964,41.218c14.609,4.615,33.391,2.619,42.734-3.424
    c1.238-12.385,10.159-23.089,17.593-28.729c-52.067-4.998-82.936-23.079-98.936-52.145c-54.466,1.305-85.372,9.036-108.029,14.695
    c-1.65,0.413-3.261,0.815-4.815,1.209c-0.134,0.028-0.269,0.038-0.403,0.038c-0.739,0-1.41-0.499-1.602-1.247
    c-0.221-0.882,0.326-1.784,1.209-2.005C3.72,267.567,5.322,267.175,6.962,266.753z" /></g>
        );
      case 'twitter':
        return (
          <g id="_x23_020201ff">
  <path fill="#020201" d="M307.875,126.404c8.923-6.734,19.259-11.948,30.478-13.262c-1.549,6.708-7.915,10.219-13.461,13.271
    c8.374-2.476,16.54-6.131,25.363-6.735c2.359-0.081,5.718,0.018,6.555,2.755c1.261,3.413-2.188,6.06-4.808,7.482
    c-9.634,4.97-20.762,5.699-30.559,10.291c20.132-1.891,40.229,5.916,55.499,18.8c18.224,15,30.271,36.717,34.664,59.812
    c16.107,4.322,33.521,1.189,48.638-5.231c-7.599,17.215-26.957,25.075-44.641,26.606c14.694,5.546,30.865,6.491,46.396,4.843
    c-12.316,13.642-31.369,18.954-49.276,18.539c-7.447,30.433-25.157,57.732-48.134,78.773
    c-44.713,40.481-106.641,59.883-166.479,56.03C140.587,394.867,83.98,366.514,50,319.469c2.971,1.738,5.465,4.133,8.301,6.061
    c26.309,19.034,61.333,25.083,92.612,16.584c18.98-4.897,36.212-15.514,49.979-29.379c-8.805,0.595-18.583-0.973-24.967-7.608
    c-3.979-3.79-5.618-10.029-3.223-15.107c2.89-6.411,9.328-10.057,15.415-12.93c-19.961,2.854-41.714-6.446-50.916-24.904
    c6.743-8.041,17.521-10.624,27.534-11.407c-11.651-3.395-23.617-7.554-32.45-16.252c-7.023-6.582-11.588-15.711-12.957-25.219
    c8.248-1.54,16.531-3.413,24.985-3.061c-19.168-9.977-36.69-28.974-35.159-51.942c36.348,13.262,72.111,28.379,106.261,46.639
    c11.949,6.564,21.88,16.063,31.649,25.436c9.462-24.571,19.618-49.241,35.006-70.796c8.247-11.336,17.98-21.888,29.938-29.361
    C311.539,119.939,309.631,123.181,307.875,126.404z"/>
</g>

        );
      case "codepen":
        return (
          <svg viewBox="0 0 1000 1000">
<g><path d="M975.4,320.4L518.1,15.5c-11-7.3-25.3-7.3-36.2,0L24.5,320.4c-9.1,6-14.5,16.3-14.5,27.2v304.9c0,10.9,5.5,21.1,14.5,27.2l457.3,304.9c5.5,3.7,11.8,5.5,18.1,5.5c6.3,0,12.6-1.8,18.1-5.5l457.3-304.9c9.1-6,14.5-16.3,14.5-27.2V347.6C990,336.7,984.5,326.4,975.4,320.4L975.4,320.4z M500,613.2L330.2,500L500,386.8L669.7,500L500,613.2z M532.6,330.1V103.7l365.8,243.9L728.6,460.8L532.6,330.1L532.6,330.1z M467.3,330.1l-196,130.7L101.5,347.6l365.8-243.9V330.1z M212.4,500L75.3,591.4V408.6L212.4,500z M271.3,539.3l196,130.7v226.4L101.5,652.5L271.3,539.3z M532.6,669.9l196-130.7l169.8,113.2L532.6,896.3V669.9z M787.5,500l137.1-91.4v182.8L787.5,500z"/></g></svg>
        );
        default:
          return (
          <svg viewBox="0 0 1000 1000">
<g><path d="M975.4,320.4L518.1,15.5c-11-7.3-25.3-7.3-36.2,0L24.5,320.4c-9.1,6-14.5,16.3-14.5,27.2v304.9c0,10.9,5.5,21.1,14.5,27.2l457.3,304.9c5.5,3.7,11.8,5.5,18.1,5.5c6.3,0,12.6-1.8,18.1-5.5l457.3-304.9c9.1-6,14.5-16.3,14.5-27.2V347.6C990,336.7,984.5,326.4,975.4,320.4L975.4,320.4z M500,613.2L330.2,500L500,386.8L669.7,500L500,613.2z M532.6,330.1V103.7l365.8,243.9L728.6,460.8L532.6,330.1L532.6,330.1z M467.3,330.1l-196,130.7L101.5,347.6l365.8-243.9V330.1z M212.4,500L75.3,591.4V408.6L212.4,500z M271.3,539.3l196,130.7v226.4L101.5,652.5L271.3,539.3z M532.6,669.9l196-130.7l169.8,113.2L532.6,896.3V669.9z M787.5,500l137.1-91.4v182.8L787.5,500z"/></g></svg>
         )
    }
  }
  render() {
    let styles = {
      fill: "black",
      verticalAlign: "middle",
      width: this.props.size, // CSS instead of the width attr to support non-pixel units
      height: this.props.size // Prevents scaling issue in IE
    };
    return (
      <svg viewBox="0 0 512 512" preserveAspectRatio="xMidYMid meet" fit
        style={this._mergeStyles(
          styles,
          this.props.style // This lets the parent pass custom styles
        )}>
          {this.renderGraphic()}
      </svg>
    );
  }
}



class About extends React.Component {
  render() {
    return (
      <div>
        <div className="about">
        
          <div className="aboutText">
            <h3>Hello, my name is Anastasiia. </h3>
            <p>An aspiring novice in front-end engineering. Once realized programming is great and <a href="https://medium.com/@korshunad/from-zero-to-react-26c5709c1858#.dfphpfr4i" rel="noopener noreferrer" target="_blank">I can do it</a>. 
              Hence rapidly started learning basic HTML, algorithms, JavaScript, React, done some learning projects with <a href="https://www.freecodecamp.com/korshunad" rel="noopener noreferrer" target="_blank">FreeCodeCamp</a>, begun building my own React-based application. 
              Recently I wrote introductory post about ES6 generators, you can check it out <a href="https://medium.com/@korshunad/genuine-novice-intro-to-generators-5bbaf22bb5c3#.2jmp5o9zt" rel="noopener noreferrer" target="_blank">here.</a></p>
            <p>Skills:</p>
          <p>HTML, CSS, Javascript, JS DOM (with jQuery, vanilla JS), fetching data from APIs</p>
            <p>In progress:</p>
            <p>React, Redux, Express, Node.js</p></div>
          <div className="me">
            <img alt="me on the mountain" id="me" src="https://raw.githubusercontent.com/korshunad/about/master/IMG_20161130_233058_processed.jpg" /></div>
        </div>
      </div>
    )
  }
}
class Works extends React.Component {
  render() {
    return (
      <div>
        <div className="works">

          <h4>Here's something I've built:</h4>

          <div className="projects">
            <div className="example" data-title="Invoice App"
              data-description="This app generates pdf invoices and is built with React.js, Redux, Node.js, MongoDB" 
              onClick={() => { window.open("https://youtu.be/D-2x7YAxKGI", "_blank", "noopener noreferrer")}}
            >
              <iframe width="500" height="280"
              src="https://www.youtube.com/embed/D-2x7YAxKGI">
              </iframe> 
            </div>
            <div className="example" data-title="Magic 8-ball App"
              data-description="Result of study of ES6 generator functions" 
              onClick={() => { window.open("https://youtu.be/ZsHk7GNMLMc", "_blank", "noopener noreferrer")}}
            >
              <iframe width="500" height="280"
              src="https://www.youtube.com/embed/ZsHk7GNMLMc">
              </iframe> 
            </div>
            <div className="example" data-title="Inventory App"
              data-description="Small inventory table built with React and antd" 
              onClick={() => { window.open("https://gentle-headland-85807.herokuapp.com/", "_blank", "noopener noreferrer")}}
            >
              <img id="example" alt="Inventory App preview" src="https://raw.githubusercontent.com/korshunad/about/master/inventory_table.png" />
            </div>
            <div className="example" data-title="Wikipedia App"
              data-description="Searches for query using Wikipedia API, animated with Animate.js" 
              onClick={() => { window.open("https://codepen.io/korshunad/full/Eyrqyk/", "_blank", "noopener noreferrer") }}
            >
                <img id="example" alt="wikiviewer app preview" src="https://raw.githubusercontent.com/korshunad/about/master/wikiviewer.jpg" />
            </div>
            <div className="example" data-title="Weather App"
              data-description="Custom animated icons with Velosity.js and Open Weather API showing local weather" 
              onClick={() => { window.open("http://codepen.io/korshunad/full/WxPvdz/", "_blank", "noopener noreferrer")}} 
            >
              <img id="example" alt="weather app preview" src="https://raw.githubusercontent.com/korshunad/about/master/weatherapp.jpg" />
            </div>
            <div className="example" data-title="Keeper"
              data-description="React- and Firebase-based application to store bookmarks online"  
              onClick={() => { window.open("https://github.com/korshunad/keeper", "_blank", "noopener noreferrer")}}
            >
              <img id="example" alt="Keeper screenshot" src="https://raw.githubusercontent.com/korshunad/about/master/keeper.jpg" />
            </div>
            <div className="example" data-title="Random Quote App"
              data-description="Inspiring random V. Frankl quotes built with Bootstrap and jQuery" 
              onClick={() => { window.open("https://korshunad.github.io/Random-Frankl/", "_blank", "noopener noreferrer")}}
            >
              <img id="example" alt="Quote Generator preview" src="https://raw.githubusercontent.com/korshunad/about/master/randomQuote.jpg" />
            </div>
            <div>
              </div>
          </div>
        </div>
      </div>
    )
  }
}
class Contacts extends React.Component {
  render() {
    var korshunad='korshunad'
    return (
      <div>
        <div className="contacts">
          <h4>You can find me here:</h4>
          <p>e-mail: {korshunad}d@gmail.com</p>
          <p>Skype: {korshunad}</p>
          <div className="social">
             <button onClick={() => {window.open("https://twitter.com/korshunad", "_blank")}}><Icon  icon="twitter" size="2.2rem" /></button>
             <button onClick={() => {window.open("http://codepen.io/korshunad/", "_blank")}}><Icon icon="codepen" size="1.6rem" /></button>
             <button onClick={() => {window.open("https://github.com/korshunad", "_blank")}}><Icon icon="octocat" size="2rem" /></button>
            </div>
        </div>
      </div>
    )
  }
}

class App extends Component {
 constructor(props) {
    super(props);
    this.toAbout = this.toAbout.bind(this);
    this.toWorks = this.toWorks.bind(this);
    this.toContacts = this.toContacts.bind(this);
    this.doScrolling = this.doScrolling.bind(this);
    this.highlightButtons = this.highlightButtons.bind(this);
  }
  componentDidMount() {
    window.addEventListener('scroll', this.highlightButtons);
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.highlightButtons);
  };

  highlightButtons(event) {
    let scrollTop = (document.documentElement.scrollTop || event.srcElement.body.scrollTop) +20;
        console.log(scrollTop);

   
    if (scrollTop >= document.querySelector('.works').offsetTop && scrollTop+500 < document.querySelector('.contacts').offsetTop) {
      document.querySelector('.buttonWorks').style.backgroundColor = 'white';
    } else {
      document.querySelector('.buttonWorks').style.backgroundColor = 'rgba(255,255,255,0.5)'
    }
    if (scrollTop < document.querySelector('.works').offsetTop) {
      document.querySelector('.buttonAbout').style.backgroundColor = 'white';
    } else {
      document.querySelector('.buttonAbout').style.backgroundColor = 'rgba(255,255,255,0.5)'
    }
    if (scrollTop+500 >= document.querySelector('.contacts').offsetTop) {
      document.querySelector('.buttonContacts').style.backgroundColor = 'white';
    } else {
      document.querySelector('.buttonContacts').style.backgroundColor = 'rgba(255,255,255,0.5)'
    }
  }
  doScrolling(elementY, startingY, duration) {
    //function credits belong to Daniel Sawka http://stackoverflow.com/questions/17722497/scroll-smoothly-to-specific-element-on-page/17731750#17731750
    // If element is close to page's bottom then window will scroll only to some position above the element.
    var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
    var diff = targetY - startingY
      // Easing function: easeInOutCubic
      // From: https://gist.github.com/gre/1650294
    var easing = function(t) {
      return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
    }
    var start

    if (!diff) return

    // Bootstrap our animation - it will get called right before next frame shall be rendered.
    window.requestAnimationFrame(function step(timestamp) {
      if (!start) start = timestamp
        // Elapsed miliseconds since start of scrolling.
      var time = timestamp - start
        // Get percent of completion in range [0, 1].
      var percent = Math.min(time / duration, 1)
        // Apply the easing.
        // It can cause bad-looking slow frames in browser performance tool, so be careful.
      percent = easing(percent)

      window.scrollTo(0, startingY + diff * percent)

      // Proceed with animation as long as we wanted it to.
      if (time < duration) {
        window.requestAnimationFrame(step)
      }
    })
  }

  toWorks(event) {
    /*document.querySelector('.works').scrollIntoView({ 
      behavior: 'smooth' 
    })*/
    let x = document.querySelector('.works');
    var startingY = window.pageYOffset
    var elementY = x.offsetTop
    this.doScrolling(elementY, startingY, 1000)
  };
  toAbout(event) {
    let x = document.querySelector('.about');
    var startingY = window.pageYOffset
    var elementY = x.offsetTop
    this.doScrolling(elementY, startingY, 1000)
      /*document.querySelector('.about').scrollIntoView({ 
        behavior: 'smooth' 
      })*/
  };

  toContacts(event) {
    let x = document.querySelector('.contacts');
    var startingY = window.pageYOffset
    var elementY = x.offsetTop
    this.doScrolling(elementY, startingY, 1000)
    
  }

  render() {

    return (
      <div>
        <div>
          <div className="header">
            <div className="head">
              <div className="logo"><p id="logo">KORSHUNAD</p></div>
            <div className="navigation">
              
              <button className="buttonAbout" onClick={this.toAbout}>about </button>
              <button className="buttonWorks" onClick={this.toWorks}>my works </button>
              <button className="buttonContacts" onClick={this.toContacts}> contacts</button>
              </div>
              
            </div>
           
          </div>
        <div className="content" onScroll={this.highlightButtons}>
          <About />
          <Works />
          <Contacts />
        </div>
          <div className="footer"><p>Made with fun, React and trianglified "Fighting Forms" by Franz Marc</p>
          </div>
         </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js